module.exports = __webpack_public_path__ + "img/dink-living-5.1d072527.jpeg";